<h3>{{ context.content }}</h3>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/subheading/subheading.component.html